module.exports = __webpack_public_path__ + "img/price-adjustment.de9e50a9.png";